import { render, staticRenderFns } from "./sceneActivity.vue?vue&type=template&id=3dbceca3&scoped=true&"
import script from "./sceneActivity.vue?vue&type=script&lang=js&"
export * from "./sceneActivity.vue?vue&type=script&lang=js&"
import style0 from "./sceneActivity.vue?vue&type=style&index=0&id=3dbceca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbceca3",
  null
  
)

export default component.exports